import Component from './EditProfile.container';

export default Component;
